<template>
  <div class="default-layout">
    <v-layout class="rounded rounded-md">
      <Header />
      <v-main class="d-flex align-center justify-center" style="min-height: 300px;">
        <slot/>
      </v-main>
    </v-layout>
  </div>
</template>